var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10181",
    "data-name": "Group 10181",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 366.47,
    height: 223.023,
    viewBox: "0 0 366.47 223.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.227,
    x2: 0.5,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.73,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cb61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9cb61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.51,
    y1: 1.253,
    x2: 0.5,
    y2: 0.504,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30d0b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#4090f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#2274dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176ad4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10179",
    "data-name": "Group 10179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10177",
    "data-name": "Group 10177",
    transform: "translate(49.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M1256,809.408c2.464,3.6.431,8.286-2.022,10.922-3.016,3.241-6.081,2.74-7.477,5.606-1.687,3.462,1.9,6.009.031,9.629-1.15,2.224-2.729,1.695-5.017,4.519-2.787,3.44-.055,4.419-2.031,6.935-6.352,8.087-8.9,2.477-12.762,4.6-5.012,2.756-8.365,5.109-10.819,4.558-9.643-2.166-6.673-8.716-11.354-11.24-6.326-3.41-9.416-17.369-5.074-22.289,2.274-2.576,4.521-2.889,4.732-5.034.305-3.1-4.222-4-4.681-7.721-.521-4.224,4.905-6.269,4.1-9.837-.787-3.478-6.357-3.354-6.714-5.837-.541-3.768,11.343-10.515,23.652-10.1,5.886.2,15.473,2.162,17.068,7.228.922,2.925-1.475,4.813-.125,8.592.982,2.748,3.155,4.285,6.033,6.264C1246.266,808.089,1251.635,803.038,1256,809.408Z",
    transform: "translate(-1196.886 -784.107)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M1246.51,836.005c1.936-.1,2.924,13.237,1.8,14.986s-3.234,3.04-3.374,4.949.685,35.737,1.369,35.247,6.354-9.354,5.222-11.419-2.415-5.255-2.149-7.954.268-6.542,1-6.448.118,6.715.627,8,.6,2.288,1.327,2.31.747-6.982,1.862-6.859.357,10.445-.026,12.356-1.693,8.508-2.9,10.937-4.885,4.976-4.975,5.8.5,20.528.5,20.528l-9.63.18s3.557-38.844,2.763-40.136-5.817-11.787-6.893-12.859-1.72-7.612-1.152-7.707.883,6.284,2.064,6.387,1.816-12.34,2.672-12.231-.831,12.91-.37,13.7,3.147,5.527,4.04,5.426-.491-34.936.275-35.328,1.341-.067,1.811,3.578,1.383,11.609,1.912,11.6a2.943,2.943,0,0,0,1.876-2.009C1246.182,848.242,1245.648,836.05,1246.51,836.005Z",
    transform: "translate(-1216.815 -812.971)",
    fill: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10178",
    "data-name": "Group 10178",
    transform: "translate(287.298 48.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M1754.349,907.875c-1.4,2.038-.244,4.691,1.145,6.183,1.708,1.835,3.443,1.552,4.234,3.174.955,1.96-1.078,3.4-.018,5.452.652,1.26,1.545.96,2.84,2.558,1.578,1.948.031,2.5,1.15,3.926,3.6,4.579,5.037,1.4,7.225,2.606,2.838,1.56,4.736,2.893,6.125,2.581,5.46-1.227,3.778-4.935,6.429-6.364,3.582-1.931,5.331-9.834,2.873-12.62-1.287-1.458-2.56-1.635-2.68-2.85-.172-1.753,2.39-2.263,2.65-4.371.3-2.391-2.777-3.549-2.32-5.569.446-1.97,3.6-1.9,3.8-3.305.306-2.134-6.422-5.953-13.391-5.716-3.333.113-8.76,1.224-9.664,4.092-.522,1.656.835,2.725.07,4.864-.556,1.555-1.786,2.426-3.415,3.546C1759.858,907.129,1756.818,904.269,1754.349,907.875Z",
    transform: "translate(-1753.717 -893.551)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M1787.922,922.934c-1.1-.057-1.655,7.494-1.019,8.484s1.831,1.721,1.91,2.8-.388,20.233-.775,19.956-3.6-5.3-2.956-6.464a8.616,8.616,0,0,0,1.217-4.5c-.15-1.528-.151-3.7-.566-3.651s-.067,3.8-.355,4.528-.338,1.3-.751,1.308-.423-3.953-1.054-3.884-.2,5.914.015,7a36.382,36.382,0,0,0,1.643,6.192c.684,1.376,2.766,2.817,2.817,3.286s-.283,11.623-.283,11.623l5.452.1s-2.014-21.992-1.564-22.724,3.294-6.674,3.9-7.28.973-4.31.652-4.363-.5,3.557-1.169,3.616-1.029-6.987-1.513-6.924.471,7.309.209,7.756-1.782,3.129-2.287,3.072.278-19.78-.156-20-.759-.038-1.026,2.026-.783,6.573-1.082,6.567a1.667,1.667,0,0,1-1.062-1.137C1788.108,929.863,1788.41,922.959,1787.922,922.934Z",
    transform: "translate(-1770.636 -909.893)",
    fill: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_708",
    "data-name": "Ellipse 708",
    cx: 183.235,
    cy: 67.004,
    rx: 183.235,
    ry: 67.004,
    transform: "translate(0 89.014)",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10180",
    "data-name": "Group 10180",
    transform: "translate(134.463 19.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M1544.767,882.342h-10.706a4.4,4.4,0,0,1,0-8.788h10.706a15.974,15.974,0,0,0,15.691-16.208v-24.3a4.256,4.256,0,1,1,8.508,0v24.3C1568.966,871.129,1558.11,882.342,1544.767,882.342Z",
    transform: "translate(-1472.574 -828.648)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6708",
    "data-name": "Path 6708",
    d: "M16.906,0h36.3c9.337,0,16.906,7.818,16.906,17.463v.847c0,9.645-7.569,17.463-16.906,17.463h-36.3C7.569,35.773,0,27.955,0,18.31v-.847C0,7.818,7.569,0,16.906,0Z",
    transform: "translate(6.992 32.658)",
    fill: "rgba(249,203,97,0.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M1407.217,830.772h0a2.641,2.641,0,0,0-2.6,2.682v22.97h15.744V844.352A13.368,13.368,0,0,0,1407.217,830.772Z",
    transform: "translate(-1400.838 -829.835)",
    fill: "#f2dad4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M1482.166,830.772h0a2.641,2.641,0,0,1,2.6,2.682v22.97h-15.744V844.352A13.368,13.368,0,0,1,1482.166,830.772Z",
    transform: "translate(-1437.741 -829.835)",
    fill: "#ffb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M1482.243,856.464h3.927a.653.653,0,0,0,.642-.663V845.727a.653.653,0,0,0-.642-.663h0a4.646,4.646,0,0,0-4.569,4.719V855.8A.653.653,0,0,0,1482.243,856.464Z",
    transform: "translate(-1444.951 -837.824)",
    fill: "#9d8140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M1407.217,830.772h0a2.641,2.641,0,0,0-2.6,2.682v22.97h15.744V844.352A13.368,13.368,0,0,0,1407.217,830.772Z",
    transform: "translate(-1400.838 -829.835)",
    fill: "#ffb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M1421.274,856.464h-3.927a.653.653,0,0,1-.642-.663V845.727a.653.653,0,0,1,.642-.663h0a4.646,4.646,0,0,1,4.569,4.719V855.8A.653.653,0,0,1,1421.274,856.464Z",
    transform: "translate(-1407.763 -837.824)",
    fill: "#9d8140"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4095",
    "data-name": "Rectangle 4095",
    width: 43.24,
    height: 33.242,
    rx: 16.227,
    transform: "translate(3.782 11.213)",
    fill: "#f9cb61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M1446.976,915.83h-9.237a5.288,5.288,0,0,1-5.2-5.372h0a5.288,5.288,0,0,1,5.2-5.372h9.237a5.288,5.288,0,0,1,5.2,5.372h0A5.288,5.288,0,0,1,1446.976,915.83Z",
    transform: "translate(-1416.836 -871.375)",
    fill: "#ffb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M1431.616,896.838a1.107,1.107,0,0,1-1.01-.669,3,3,0,0,0-4.87,0,1.1,1.1,0,0,1-1.471.565,1.162,1.162,0,0,1-.546-1.52,5.125,5.125,0,0,1,8.905,0,1.162,1.162,0,0,1-.547,1.52A1.081,1.081,0,0,1,1431.616,896.838Z",
    transform: "translate(-1411.725 -864.411)",
    fill: "#192b59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M1466.673,896.849a1.084,1.084,0,0,1-.468-.106,1.171,1.171,0,0,1-.542-1.528,5.126,5.126,0,0,1,8.906,0,1.162,1.162,0,0,1-.547,1.52,1.1,1.1,0,0,1-1.471-.565,2.993,2.993,0,0,0-4.879.018A1.094,1.094,0,0,1,1466.673,896.849Z",
    transform: "translate(-1435.76 -864.411)",
    fill: "#192b59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M1454.058,910.533a1.086,1.086,0,0,0-1.558-.194,2.653,2.653,0,0,1-1.1.509v-1.54a1.578,1.578,0,0,0,.627-.625l.758-1.355a1.63,1.63,0,0,0-1.365-2.443h-1.515a1.63,1.63,0,0,0-1.366,2.443l.757,1.355a1.582,1.582,0,0,0,.627.625v1.56a2.683,2.683,0,0,1-1.122-.483,1.086,1.086,0,0,0-1.552.243,1.171,1.171,0,0,0,.234,1.6,5.387,5.387,0,0,0,6.381-.087A1.172,1.172,0,0,0,1454.058,910.533Z",
    transform: "translate(-1425.144 -871.262)",
    fill: "#192b59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4096",
    "data-name": "Rectangle 4096",
    d: "M0,0H81.634a0,0,0,0,1,0,0V38.549a4.006,4.006,0,0,1-4.006,4.006H4.006A4.006,4.006,0,0,1,0,38.549V0A0,0,0,0,1,0,0Z",
    transform: "translate(1.95 47.155)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M1479.495,949.475h-81.931a1.843,1.843,0,0,1-1.776-2.172l1.924-11.735h81.634l1.925,11.735A1.843,1.843,0,0,1,1479.495,949.475Z",
    transform: "translate(-1395.762 -888.414)",
    fill: "#4e9cff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatBorder);
export default __webpack_public_path__ + "static/media/cat-border.25beb7c4f3d807bf03c8c0aa77ef30ca.svg";
export { ForwardRef as ReactComponent };